import { createSlice } from "@reduxjs/toolkit";
import {
  initialState,
  handleResetReportFilter,
  handleResetReportFilterResult,
  handlePendingForFetchTransactionLogsByQuery,
  handleRejectForFetchTransactionLogsByQuery,
  handleFullFillForFetchTransactionLogsByQuery,
  handlePendingForFetchDependentDropdowns,
  handleFullFillForFetchDependentDropdowns,
  handleRejectForFetchDependentDropdowns,
  handleRejectForFetchTransactionDetail,
  handleFullFillForFetchTransactionDetail,
  handlePendingForFetchTransactionDetail,
  handleResetState
} from "./TransactionLogReportReducers";
import {
  fetchDependentDropdowns,
  fetchTransactionDetail,
  fetchTransactionLogsByQuery
} from "./TransactionLogReportAsyncThunks";

const TransactionLogReportSlice = createSlice({
  name: "transactionLogReport",
  initialState,
  reducers: {
    handleResetReportFilter,
    handleResetReportFilterResult,
    handleResetState
  },
  extraReducers(builder) {
    builder
      .addCase(
        fetchDependentDropdowns.pending,
        handlePendingForFetchDependentDropdowns
      )
      .addCase(
        fetchDependentDropdowns.fulfilled,
        handleFullFillForFetchDependentDropdowns
      )
      .addCase(
        fetchDependentDropdowns.rejected,
        handleRejectForFetchDependentDropdowns
      )
      .addCase(
        fetchTransactionDetail.pending,
        handlePendingForFetchTransactionDetail
      )
      .addCase(
        fetchTransactionDetail.fulfilled,
        handleFullFillForFetchTransactionDetail
      )
      .addCase(
        fetchTransactionDetail.rejected,
        handleRejectForFetchTransactionDetail
      )
      .addCase(
        fetchTransactionLogsByQuery.pending,
        handlePendingForFetchTransactionLogsByQuery
      )
      .addCase(
        fetchTransactionLogsByQuery.fulfilled,
        handleFullFillForFetchTransactionLogsByQuery
      )
      .addCase(
        fetchTransactionLogsByQuery.rejected,
        handleRejectForFetchTransactionLogsByQuery
      );
  }
});

export const TransactionLogReportAction = TransactionLogReportSlice.actions;
export default TransactionLogReportSlice.reducer;
